var render = function render(_c,_vm){return (_vm.props.url && _vm.props.external)?_c('recess-link',{staticClass:"link",attrs:{"href":_vm.props.url,"blank-target":_vm.props.external}},[_vm._t("default")],2):(_vm.props.url)?_c('recess-link',{staticClass:"link",attrs:{"to":_vm.props.url}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }